import CalendarContainer from "../../components/applications/calendar";

const Calendar = () => {
  return <CalendarContainer />;
};

export default Calendar;
